import styled from 'styled-components';

/**
 * "Mount hidden, reveal once ready" pair shared by the emails-v2 page and the
 * email-thread drawer: mount the real content immediately (so iframes start
 * loading in the background) but keep it visually hidden and show this
 * overlay until the caller's readiness signal (see EmailTranscript's
 * `onExpandedContentReady`) fires. Place inside a `position: relative` ancestor.
 */
export const ContentReadyOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--white-100, #fff);
  z-index: 1;
`;

export const HiddenUntilReady = styled.div<{ $hidden: boolean }>`
  height: 100%;
  visibility: ${({ $hidden }) => ($hidden ? 'hidden' : 'visible')};
`;
